import React, {useContext, useRef, useState} from 'react';
import {AgentContext} from "../context/agent-context.jsx";
import projectUtils from "../../../../../utils/project-utils.js";
import Button from "../../../../../components/button/button.jsx";
import {FaTimes} from "react-icons/fa";
import {Modal} from "../../../../../components/modal/modal.jsx";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";
import {Card} from "../../../../../components/card/card.jsx";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const UserImage = () => {
    const {user, setUser, id, setChanges} = useContext(AgentContext);
    const imgRef = useRef();
    const triggerInput = () => imgRef.current?.click();
    const [open, setOpen] = useState(false);
    const [imgScr, setImgScr] = useState(undefined);

    const attachUserImage = ({target: {files}}) => {
        const file = files[0];
        const reader = new FileReader();

        if (file.size >= 2000000) {
            let message = 'Tamanho máximo de arquivo excedido. Limite: 2MB.';
            projectUtils.swalErrorMessage('', message, 'Ok');
            return;
        }

        reader.onload = function (e) {
            setImgScr(e.target.result);
        }

        reader.readAsDataURL(file);
        setUser(prev => ({...prev, general: {...user.general, imageId: null, image: file, removeImage: false}}))
        setChanges("image");
    }

    const removeFile = () => {
        setImgScr(null);
        setUser(prev => ({...prev, general: {...user.general, imageId: null, image: null, removeImage: true}}))
        setChanges("image");
    }

    const openModal = ({target}) => {
        if ((!user.general.imageId && !imgScr) || target.classList.contains("btn-danger") || target.classList.contains("fa-close")) return;
        setOpen(true);
    }

    return (
        <>
            <Card className={"mb-2"}>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12">
                            <div className="relative">
                                {
                                    (user.general.imageId || imgScr) &&
                                    <Button target={"danger"} className={"absolute !w-[25px] !h-[25px] !p-0 right-[5px] top-[5px]"} onClick={() => removeFile()} title="Remover imagem">
                                        <FaTimes />
                                    </Button>
                                }
                                <div className="overflow-hidden h-[158px] bg-center bg-no-repeat bg-contain cursor-pointer border border-[#e0e0e0] rounded p-1" id="image-user" onClick={openModal}
                                     style={{
                                         backgroundImage: user.general.imageId ? `url(${API_KEEPER}/general/image/${user?.general.imageId})` : imgScr ? `url(${imgScr})` : `url(${getAssetPath("img/user.png")})`,
                                     }}
                                ></div>
                                <input type="hidden" name="imageId" value={user.general.imageId ?? ""}/>
                                <input type="file" accept="image/png, image/jpeg" className="hidden" name="image" onChange={attachUserImage}
                                       ref={imgRef}/>
                                <Button className={"w-full"} onClick={triggerInput}>
                                    <span>Selecionar foto</span>
                                </Button>
                                <small>* Tamanho máximo 2MB</small>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <Modal isCloseClick={false} open={open} setOpen={() => setOpen(false)} onClick={() => setOpen(false)} centered size="xl" backdrop="static" keyboard={false} title={"Foto"}>
                <Modal.Body className="p-2">
                    <div className={"bg-center bg-no-repeat bg-contain overflow-hidden h-[500px]"} style={{
                        backgroundImage: user.general.imageId ? `url(${API_KEEPER}/general/image/${user?.general.imageId})` : imgScr ? `url(${imgScr})` : `url(${getAssetPath("user.png")})`,
                    }}
                    ></div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default UserImage;